import React, { useEffect } from 'react';

import HomePage from './components/HomePage';
import { BonusProvider } from './context/BonusContext';
import { RequestHistoryProvider } from './context/RequestHistoryContext';
import { StyleProvider } from './context/StyleContext';
import { StaticProvider, useStatic } from './context/StaticContext';
import { MaintenanceProvider } from './context/MaintenanceContext';

const App = () => {
  return (
    <StaticProvider>
      <MaintenanceProvider>
        <ReCaptchaWrapper />
      </MaintenanceProvider>
    </StaticProvider>
  );
};

const ReCaptchaWrapper = () => {
  const { title } = useStatic();

  useEffect(() => {
    if (title) {
      document.title = title;
    }
  }, [title]);

  return (
      <StyleProvider>
        <BonusProvider>
          <RequestHistoryProvider>
            <HomePage />
          </RequestHistoryProvider>
        </BonusProvider>
      </StyleProvider>
  );
};

export default App;
